import {
  NEW_SURA_TEMPLATES_SMS,
  NEW_CHANGE_CARD_TEMPLATE_SMS,
  NEW_PAYMENT_LINK_TEMPLATE_SMS,
  NEW_DIRECT_PAYMENT_PROCESS_TEMPLATE_SMS,
  NEW_AGENT_PAYMENT_PROCESS_TEMPLATE_SMS,
  NEW_DIRECT_INSUFFICIENT_FUNDS_TEMPLATE_SMS,
  NEW_AGENT_INSUFFICIENT_FUNDS_TEMPLATE_SMS,
  SUBMIT_LOADING
} from '../actions/suraSmsTemplateActions';

const initialState = {
  sura_templates_sms                : null,
  change_card_sms                   : null,
  payment_link_sms                  : null,
  direct_payment_process_sms        : null,
  agent_payment_process_template    : null,
  direct_insufficient_funds_sms     : null,
  agent_insufficient_funds_sms      : null,
  isLoadingButton                   : false
} // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case NEW_SURA_TEMPLATES_SMS:
      newState = { sura_templates_sms: payload };
      return { ...state, ...newState };

    case NEW_CHANGE_CARD_TEMPLATE_SMS:
      newState = { change_card_sms: payload };
      return { ...state, ...newState };

    case NEW_PAYMENT_LINK_TEMPLATE_SMS:
      newState = { payment_link_sms: payload };
      return { ...state, ...newState };

    case NEW_DIRECT_PAYMENT_PROCESS_TEMPLATE_SMS:
      newState = { direct_payment_process_sms: payload };
      return { ...state, ...newState };

    case NEW_AGENT_PAYMENT_PROCESS_TEMPLATE_SMS:
      newState = { agent_payment_process_template: payload };
      return { ...state, ...newState };

    case NEW_DIRECT_INSUFFICIENT_FUNDS_TEMPLATE_SMS:
      newState = { direct_insufficient_funds_sms: payload };
      return { ...state, ...newState };

    case NEW_AGENT_INSUFFICIENT_FUNDS_TEMPLATE_SMS:
      newState = { agent_insufficient_funds_sms: payload };
      return { ...state, ...newState };

    case SUBMIT_LOADING:
      return {...state, ...payload };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/suraSmsTemplateReducer.js